import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledScoringSettingsPageLoaderHeader = styled(Flex)`
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
`;
